<nts-iframe [class.in-iframe]="inIframe" #iframe [url]="url"></nts-iframe>
